import { CertificadoInterface } from "components/componentesGenerales/firmaElectronica/interfaces/firmaInterfaces";
import { DataSolicitudPromocion } from "interfaces/promociones/promocionesInterface";
import { FileArgs } from "interfaces/serviciosGenerales/serviciosGeneralesInterface";

const verifyDataLocalStorage = (
  data: string,
  verifyIncludesProperties: any
) => {
  if (data) {
    //los datos existen en localStorage
    try {
      const parseData = JSON.parse(data);
      const result = verifyIncludesProperties(parseData);
      return result;
    } catch (error) {
      return "El formato y la estructura del objeto no es valido";
    }
  } else {
    //los datos no existen en localStorage
    return "El formato y la estructura del objeto no es valido";
  }
};

const verifyIncludesPropertiesCerKeyList = (
  arrayCerKeyList: CertificadoInterface[]
) => {
  arrayCerKeyList.forEach((cerKey) => {
    if (!cerKey.cert || !cerKey.key) {
      return "estructura no valida";
    }
  });

  const validatePropertiesCer = arrayCerKeyList.find(
    (cerkey) => !cerkey?.cert?.certBase64 || !cerkey?.cert?.certBase64
  );

  const validatePropertiesKey = arrayCerKeyList.find(
    (cerkey) => !cerkey?.key?.name || !cerkey?.key?.keyBase64
  );

  if (validatePropertiesCer || validatePropertiesKey) {
    return "estructura no valida";
  }

  return arrayCerKeyList;
};

const verifyIncludesPropertiesListFiles = (arrayListFiles: FileArgs[]) => {
  const validatePropertiesListFiles = arrayListFiles.find(
    (list) => !list.digestion || !list.extension || !list.path || !list.size
  );

  if (validatePropertiesListFiles) {
    return "estructura no valida";
  }

  const existFileName = arrayListFiles.find(
    (list) => list.fileName || list.filename
  );

  if (!existFileName) {
    return "estructura no valida";
  }

  return arrayListFiles;
};

const verifyIncludesPropertiesIdSolicitudPromocion = (
  ObjIdSolicitudPromocion: DataSolicitudPromocion
) => {
  if (!Array.isArray(ObjIdSolicitudPromocion.promoventes)) {
    return "estructura no valida";
  }

  if (!ObjIdSolicitudPromocion.resolucion) {
    ObjIdSolicitudPromocion.resolucion = "";
    return ObjIdSolicitudPromocion;
  }

  if (Object.keys(!ObjIdSolicitudPromocion.resultados).length) {
    return "estructura no valida";
  }

  return ObjIdSolicitudPromocion;
};

export {
  verifyDataLocalStorage,
  verifyIncludesPropertiesCerKeyList,
  verifyIncludesPropertiesListFiles,
  verifyIncludesPropertiesIdSolicitudPromocion,
};
